// import React, { useEffect, useState } from "react";
// import { getImgPath } from "../common/helper";
// import AccountLoader from "../manageAccount/accountLoader";
// import { Link } from "react-router-dom";


// function BookingCounters() {

//   const [data, setData] = useState([])
//   const [loader, setLoader] = useState(false);

//   useEffect(()=>{
//     getCountersData();
//   },[])

//   const getCountersData = async () => {
//     const url = `${window.url}/api/resource/getBookingCounterContent`;
//     try {
//       setLoader(true);
//       const response = await fetch(url);
//       try {
//         const data = await response.json();
//         if (data.Success == true && data.data.length > 0) {
//           setData(data.data)
//         }
//         else {
//           setData([])
//         }
//         setLoader(false);
//       } catch (error) {
//         setLoader(false);
//         return false;
//       }
//     }
//     catch (err) {
//       setLoader(false);
//       return err;
//     }
//   }

//   // const handleDownload = (url, filename) => {
//   //   const link = document.createElement('a');
//   //   const fileName = url.split('/').pop();
//   //   link.href = url;
//   //   link.download = fileName;
//   //   link.target =  "_blank";
//   //   link.rel ="noopener noreferrer"
//   //   link.style.display = 'none'; // Hide the link
//   //   document.body.appendChild(link);
//   //   link.click();
//   //   document.body.removeChild(link);
//   // };

//   // Function to handle file download
//   const handleDownload = (url) => {
//     try {
//       // Create an anchor element and trigger download
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = url.split('/').pop(); // Extract filename from URL
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     } catch (error) {
//       console.error('Error downloading file:', error);
//     }
//   };

//    // Function to extract the file name from URL
//   const getFileNameFromUrl = (url) => {
//     try {
//       const decodedUrl = decodeURIComponent(url);
//       const urlObj = new URL(decodedUrl);
//       const filename = urlObj.pathname.split('/').pop();
//       return decodeURIComponent(filename); // Decode the extracted filename
//     } catch (error) {
//       console.error('Error extracting file name:', error);
//       return 'download.pdf'; // Fallback filename
//     }
//   };

//   return (
//     <>
//       {loader && <AccountLoader />}
//       <div className="body_style">
//       <div className="letters-color-section">
//         <h3 className="letters-color-section-main-heading">Booking Counters</h3>
//         <div className="letters-color-section-sub-heading-section">
//           <h5 className="letters-color-section-sub-heading">
//             Franchisee Counters in NEKRTC Jurisdiction in Karnataka State
//           </h5>
//         </div>
//        { data && data?.length >0 && <div className="letters-color-section-table-section">
//           <div className="heading-main">
//             <div className="heading">
//               <table>
//                 <tbody>
//               {data.map((item, index) => (
//                 <tr key={"counterData_"+index}>
//                   <td>{index+1}.</td>
//                   <td>
//                     {item?.contentName}
//                   </td>
//                   <td className="td-third">
//                     <a href={item.content} download={getFileNameFromUrl(item.content)}>
//                       <img
//                         src={getImgPath("/img/aboutus/download_icon.png")}
//                         alt="download"
//                         width="18"
//                         height="22"
//                       />
//                       <span>Download</span>
//                     </a>
//                   </td>
//                 </tr>
//                  ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>}
//       </div>
//     </div>
//     </>
//   );
// }

// export default BookingCounters;

import React from "react";
import { getImgPath } from "../common/helper";

function BookingCounters() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">Booking Counters</h3>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            Franchisee Counters in NEKRTC Jurisdiction in Karnataka State
          </h5>
        </div>
        <div className="letters-color-section-table-section">
          <div className="heading-main">
            <div className="heading">
              <table>
                <tr>
                  <td>1.</td>
                  <td>
                    Booking Counters Operated by KSRTC and Sister Corporations
                  </td>
                  <a href ="https://ksrtc.karnataka.gov.in/storage/pdf-files/Booking%20Counter/BookingCountersByKSRTC.pdf" target="_blank">
                     <td className="td-third">
                        <span>
                          <img
                            src={getImgPath("/img/aboutus/download_icon.png")}
                            alt="download"
                            width="18"
                            height="22"
                          />
                        </span>
                        <span>Download</span>
                     </td>
                  </a>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>
                    Franchisee Counters in Bangalore City and Suburban Area
                  </td>
                  <a href="https://ksrtc.karnataka.gov.in/storage/pdf-files/Booking%20Counter/FranchiseesInBangaloreCity.pdf" target="_blank">
                    <td className="td-third">
                      <span>
                        <img
                          src={getImgPath("/img/aboutus/download_icon.png")}
                          alt="download"
                          width="18"
                          height="22"
                        />
                      </span>
                      <span>Download</span>
                    </td>
                  </a>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>
                    Franchisee Counters in KSRTC Jurisdiction in Karnataka State
                  </td>
                  <a href ="https://ksrtc.karnataka.gov.in/storage/pdf-files/Booking%20Counter/KSRTCfranchisees.pdf" target="_blank">
                      <td className="td-third">
                      <span>
                        <img
                          src={getImgPath("/img/aboutus/download_icon.png")}
                          alt="download"
                          width="18"
                          height="22"
                        />
                      </span>
                      <span>Download</span>
                    </td>
                  </a>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>Franchisee in KKRTC Jurisdiction in Karnataka State</td>
                  <a href="https://ksrtc.karnataka.gov.in/storage/pdf-files/Booking%20Counter/NEKRTCfranchisees.pdf" target="_blank">
                    <td className="td-third">
                      <span>
                        <img
                          src={getImgPath("/img/aboutus/download_icon.png")}
                          alt="download"
                          width="18"
                          height="22"
                        />
                      </span>
                      <span>Download</span>
                    </td>
                  </a>
                </tr>
                <tr>
                  <td>5.</td>
                  <td>
                    Franchisee Counters in NWKRTC Jurisdiction in Karnataka
                    State
                  </td>
                   <a href="https://ksrtc.karnataka.gov.in/storage/pdf-files/Booking%20Counter/FranchiseeCountersInNWKRTC.pdf" target="_blank">
                    <td className="td-third">
                      <span>
                        <img
                          src={getImgPath("/img/aboutus/download_icon.png")}
                          alt="download"
                          width="18"
                          height="22"
                        />
                      </span>
                      <span>Download</span>
                    </td>
                   </a>
                </tr>
                <tr>
                  <td>6.</td>
                  <td>Franchisee Counters in Neighbouring States</td>
                  <a href="https://ksrtc.karnataka.gov.in/storage/pdf-files/Booking%20Counter/FInNeighbouringStates.pdf" target="_blank">
                    <td className="td-third">
                      <span>
                        <img
                          src={getImgPath("/img/aboutus/download_icon.png")}
                          alt="download"
                          width="18"
                          height="22"
                        />
                      </span>
                      <span>Download</span>
                    </td>
                  </a>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingCounters;
